import { Controller } from "@hotwired/stimulus";
import {
  closeOverlay,
  showOverlay,
} from "../website/javascript/features/overlay";

// Connects to data-controller="v2-video"
export default class extends Controller {
  connect() {
    const btnEl = this.element.querySelector(".js-video-btn");
    const overlayEl = this.element.querySelector(".js-video-overlay");

    if (!btnEl || !overlayEl) {
      return;
    }

    btnEl.addEventListener("click", () => showOverlay(overlayEl));
  }
}
